import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import TextArea from '@/common/components/TextArea'
import { FormTransformers } from '@/common/utils/formTransformers'
import useDisableTmaisClient from '@/features/tmaisUsers/hooks/useDisableTmaisUser'
import { disableTmaisUserSchema, DisableTmaisUserValidationSchema } from '@/features/tmaisUsers/schemas/disableTmaisUser.schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { useQueryClient } from '@tanstack/react-query'
import { Dispatch, SetStateAction, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

interface DisableTmaisUserModalProps {
  tmaisUserId?: string
  setMessages: Dispatch<SetStateAction<boolean | string[]>>
}

export const DisableTmaisUserModal = ({ tmaisUserId, setMessages }: DisableTmaisUserModalProps) => {
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)

  const { mutate: disableTmaisUser } = useDisableTmaisClient({
    id: tmaisUserId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tmaisUser', tmaisUserId] })
      reset()
      setIsOpen(false)
    },
    onError: (error) => FormTransformers.errorsTransformer({ setError, setMessages })(error),
  })

  const {
    register,
    reset,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<DisableTmaisUserValidationSchema>({
    resolver: zodResolver(disableTmaisUserSchema),
  })

  const onSubmit: SubmitHandler<DisableTmaisUserValidationSchema> = (data) => {
    disableTmaisUser(data)
  }

  return (
    <Modal
      Trigger={
        <Button
          operationKlassToCheckPermission="Admin::Tmais::Users::Disable"
          type="button"
          variant="outline-error"
        >
          Bloquear
        </Button>
      }
      title="Bloquear cliente"
      subtitle="Preencha o motivo para bloqueio do cliente"
      subtitleClassName="mt-1 text-white-300"
      useCancellableFooter
      confirmButtonText='Confirmar bloqueio'
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={handleSubmit(onSubmit)}
      body={
        <form className="text-white-800">
          <TextArea
            label="Motivo do bloqueio"
            placeholder="Escreva aqui o motivo do bloqueio"
            markAsRequired
            {...register('disable_reason')}
            errorMessage={errors.disable_reason?.message}
            variant={errors.disable_reason?.message ? 'error' : 'default'}
          />
        </form>
      }
    />
  )
}
